import React from "react";

/**
 * Tiny ★ pill for Founder members. Comes in two visual flavours so we can
 * tell apart Founder Sellers (gold-pink) from Founder Buyers (blue-white):
 *
 *   <FounderPill is_founder={u.is_founder} variant="seller" />
 *   <FounderPill is_founder={u.is_founder} variant="buyer" />
 *   <FounderPill is_founder={u.is_founder} account_type={u.account_type} />
 *
 * Renders nothing when the user isn't a Founder. CSS lives in index.css
 * (`.bidora-founder-pill-seller` / `.bidora-founder-pill-buyer`).
 */
export default function FounderPill({
  is_founder,
  variant,
  account_type,
  size = "sm",
  className = "",
  testid,
}) {
  if (!is_founder) return null;
  // Auto-derive variant from account_type when not explicitly set.
  let v = variant;
  if (!v && account_type) {
    v = account_type.includes("seller") ? "seller" : "buyer";
  }
  if (v !== "buyer") v = "seller"; // default: seller (gold-pink)
  const variantClass =
    v === "buyer" ? "bidora-founder-pill-buyer" : "bidora-founder-pill-seller";
  const px = size === "xs" ? "px-1 py-[1px] text-[8px]" : "px-1.5 py-0.5 text-[9px]";
  return (
    <span
      className={`inline-flex items-center gap-0.5 rounded-full font-extrabold uppercase tracking-wider ${variantClass} ${px} ${className}`}
      title={`Founder ${v} — early supporter`}
      data-testid={testid || `founder-pill-${v}`}
    >
      ★ Founder
    </span>
  );
}
